<template>
  <FinishedAuctionsCatalogReportedToBidArtworksList />
</template>

<script>
  import FinishedAuctionsCatalogReportedToBidArtworksList from './reported_to_bid_artworks/list';

  export default {
    name: 'ReportedToBidArtworks',
    components: {
      FinishedAuctionsCatalogReportedToBidArtworksList,
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/reported_to_bid_artworks.vue?7dc58ec2